import { useState, useEffect } from "react";
import { portalClienteTarefas } from "../api/functions";

const BRAND = { primary: "#0FC9C5", card: "#1e293b", border: "#334155" };

const STATUS_CONFIG = {
  "Pendente":      { color: "#f59e0b", bg: "#451a0320", border: "#92400e40" },
  "Em andamento":  { color: "#60a5fa", bg: "#1e3a5f20", border: "#2563eb40" },
  "Em revisão":    { color: "#a78bfa", bg: "#1e1b4b20", border: "#6d28d940" },
  "Concluída":     { color: "#4ade80", bg: "#052e1620", border: "#16a34a40" },
  "Cancelada":     { color: "#94a3b8", bg: "#1e293b20", border: "#33415540" },
};

const PRIORIDADE_CONFIG = {
  "Alta":    { color: "#f87171", label: "🔴 Alta" },
  "Média":   { color: "#fbbf24", label: "🟡 Média" },
  "Baixa":   { color: "#4ade80", label: "🟢 Baixa" },
  "Urgente": { color: "#f43f5e", label: "🚨 Urgente" },
};

export default function Tarefas({ usuario }) {
  const [tarefas, setTarefas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtroStatus, setFiltroStatus] = useState("todas");
  const [busca, setBusca] = useState("");

  useEffect(() => {
    const carregar = async () => {
      try {
        const data = await portalClienteTarefas({ empresa_id: usuario.empresa_id, usuario_id: usuario.id });
        setTarefas(data.tarefas || []);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    };
    carregar();
  }, [usuario]);

  const tarefasFiltradas = tarefas.filter(t => {
    const matchStatus = filtroStatus === "todas" || t.status === filtroStatus;
    const matchBusca = !busca || t.titulo?.toLowerCase().includes(busca.toLowerCase());
    return matchStatus && matchBusca;
  });

  const abertas = tarefas.filter(t => t.status !== "Concluída" && t.status !== "Cancelada").length;
  const atrasadas = tarefas.filter(t => t.prazo && new Date(t.prazo) < new Date() && t.status !== "Concluída" && t.status !== "Cancelada").length;

  if (loading) return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "300px", color: "#64748b" }}>
      <div style={{ textAlign: "center" }}><div style={{ fontSize: "32px", marginBottom: "12px" }}>⏳</div><p>Carregando tarefas...</p></div>
    </div>
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <div>
        <h2 style={{ color: "#f1f5f9", fontSize: "20px", fontWeight: "700", marginBottom: "4px" }}>✅ Suas Tarefas</h2>
        <p style={{ color: "#64748b", fontSize: "13px" }}>{abertas} em aberto · {atrasadas > 0 ? <span style={{ color: "#f87171" }}>{atrasadas} atrasada(s)</span> : "nenhuma atrasada"}</p>
      </div>

      {/* Filtros */}
      <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
        <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="🔍 Buscar tarefa..." style={{
          flex: 1, minWidth: "200px", padding: "9px 14px", background: BRAND.card, border: `1px solid ${BRAND.border}`,
          borderRadius: "10px", color: "#f1f5f9", fontSize: "13px", outline: "none"
        }} />
        {["todas", "Pendente", "Em andamento", "Concluída"].map(s => (
          <button key={s} onClick={() => setFiltroStatus(s)} style={{
            padding: "9px 16px", borderRadius: "10px", border: "none", cursor: "pointer", fontSize: "13px", fontWeight: "600",
            background: filtroStatus === s ? BRAND.primary : BRAND.card,
            color: filtroStatus === s ? "#fff" : "#94a3b8",
          }}>{s === "todas" ? "Todas" : s}</button>
        ))}
      </div>

      {/* Lista */}
      {tarefasFiltradas.length === 0 ? (
        <div style={{ background: BRAND.card, border: `1px solid ${BRAND.border}`, borderRadius: "16px", padding: "40px", textAlign: "center" }}>
          <div style={{ fontSize: "40px", marginBottom: "12px" }}>🎉</div>
          <p style={{ color: "#64748b" }}>Nenhuma tarefa encontrada.</p>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          {tarefasFiltradas.map((t, i) => {
            const statusCfg = STATUS_CONFIG[t.status] || STATUS_CONFIG["Pendente"];
            const prioridadeCfg = PRIORIDADE_CONFIG[t.prioridade];
            const atrasada = t.prazo && new Date(t.prazo) < new Date() && t.status !== "Concluída" && t.status !== "Cancelada";

            return (
              <div key={i} style={{ background: BRAND.card, border: `1px solid ${atrasada ? "#7f1d1d" : BRAND.border}`, borderRadius: "12px", padding: "16px 18px" }}>
                <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "12px" }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ color: "#f1f5f9", fontWeight: "600", fontSize: "14px", marginBottom: "6px" }}>{t.titulo}</div>
                    {t.descricao && <div style={{ color: "#64748b", fontSize: "12px", marginBottom: "8px", lineHeight: "1.5" }}>{t.descricao.slice(0, 120)}{t.descricao.length > 120 ? "..." : ""}</div>}
                    <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
                      {t.prazo && (
                        <span style={{ fontSize: "12px", color: atrasada ? "#f87171" : "#64748b" }}>
                          📅 {t.prazo}{atrasada ? " ⚠️ atrasada" : ""}
                        </span>
                      )}
                      {t.responsavel_nome && <span style={{ fontSize: "12px", color: "#64748b" }}>👤 {t.responsavel_nome}</span>}
                      {prioridadeCfg && <span style={{ fontSize: "11px", color: prioridadeCfg.color }}>{prioridadeCfg.label}</span>}
                    </div>
                  </div>
                  <span style={{ padding: "4px 12px", borderRadius: "20px", fontSize: "11px", fontWeight: "600", whiteSpace: "nowrap", background: statusCfg.bg, color: statusCfg.color, border: `1px solid ${statusCfg.border}` }}>{t.status}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
